import shouldDisableOption from '../utils/shouldDisableOption';
import { observer } from 'mobx-react-lite';
import { IconButton } from 'office-ui-fabric-react/lib/Button';
import { TooltipHost } from 'office-ui-fabric-react/lib/Tooltip';
import loc from 'owa-localize';
import { ClientItem } from 'owa-mail-store';
import React from 'react';
import { UserMarkup_createTask } from './UserMarkupPopup.locstring.json';
import { lazySwitchListAndCreateTasks } from 'owa-time-panel-todo';
import { HIGHLIGH_TASK_ENTITY_SUBTYPE } from 'owa-todo-types';
import { lazyOpenTasksView } from 'owa-time-panel';
import { ControlIcons } from 'owa-control-icons';
import { logUsage } from 'owa-analytics';

const styles = require('./UserMarkupPopup.scss');

export interface TaskOptionProps {
    selectedText: string;
    item: ClientItem;
    destroyPopupDivCallback: () => void;
}

const TaskOption = observer(function TaskOption(props: TaskOptionProps) {
    const { selectedText, item, destroyPopupDivCallback } = props;

    const onClick = React.useCallback(() => {
        lazyOpenTasksView.importAndExecute('CreateTaskFromHighlight');

        lazySwitchListAndCreateTasks.importAndExecute([
            {
                Subject: selectedText,
                LinkedEmail: {
                    Id: item.ItemId.Id,
                    EntitySubtype: HIGHLIGH_TASK_ENTITY_SUBTYPE,
                    DisplayName: selectedText,
                },
            },
        ]);
        logUsage('UserMarkup_createTask');
        destroyPopupDivCallback();
    }, [selectedText, item, destroyPopupDivCallback]);

    const isDisabled = shouldDisableOption(item);

    return (
        <TooltipHost content={loc(UserMarkup_createTask)}>
            <IconButton
                className={styles.UserMarkupPopupButton}
                iconProps={{ iconName: ControlIcons.ToDoLogoOutline }}
                onClick={onClick}
                disabled={isDisabled}
            />
        </TooltipHost>
    );
});

export default TaskOption;
